import { defineMessages } from "react-intl";
import { addMiddleware } from "redux-dynamic-middlewares";
import { isEmpty } from "ramda";
import * as profileServiceApi from "../api/profileServiceApi";
import { fetchBranding } from "./otherActions";
import * as types from "../constants/ActionTypes";
import lspMiddleware from "../utils/lspMiddleware";
import localStorage from "../storage/localStorage";

const messages = defineMessages({
  failedToFetchUserInfo: {
    id: "failedToFetchUserInfo",
    defaultMessage: `We couldn't load your user information.`
  }
});

export const fetchMe = dataVersion => dispatch => {
  return profileServiceApi.fetchMe().then(user => {
    if (user) {
      const email = user.email || user.username;
      const { getBrandingCacheState } = localStorage({
        dataVersion,
        email
      });

      addMiddleware(lspMiddleware({ dataVersion, email }));

      dispatch({
        type: types.FETCH_USER_RECEIVED,
        user
      });

      const brandingCacheState = getBrandingCacheState();
      if (!isEmpty(brandingCacheState)) {
        dispatch({
          type: types.FETCH_BRANDING_RECEIVED,
          data: {
            ...brandingCacheState
          }
        });
      }

      dispatch(fetchBranding());
    } else {
      dispatch({
        type: types.FETCH_USER_FAILURE,
        messageDescriptor: messages.failedToFetchUserInfo
      });
    }
  });
};
